import React, { useState } from "react";
import { Rate, Typography, message } from "antd";

import {
  CheckOutlined,
  SafetyOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import Table from "components/Tables/Table";
import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import { StyledModal } from "components/App/styled";

export default function CustomTable({ data, reload, setReload }) {
  const [activeItem, setActiveItem] = useState(null);
  const showModal = () => {
    setActiveItem(true);
  };

  // const handleOk = () => {
  //   setActiveItem(false);
  // };

  const handleUpdate = (status) => {
    Fetch.post(
      "/comments/changeStatus",
      { id: activeItem.id, product_id: activeItem.product_id, status },
      (res) => {
        console.log("comments", res);
        if (res?.id) {
          setReload(true);
          setActiveItem(null);
        } else {
          if (res?.errors?.name) {
            message.error(res?.errors.name[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
          return false;
        }
      }
    );
  };
  const handleReject = () => {
    handleUpdate(2);
  };
  const handleApprove = () => {
    handleUpdate(1);
  };

  return (
    <>
      <StyledModal
        title={<div style={{ paddingTop: 20 }}>{activeItem?.title}</div>}
        visible={!!activeItem}
        cancelText={"رد کردن"}
        okText={"تایید نظر"}
        onCancel={() => setActiveItem(null)}
        onOk={handleApprove}
        okButtonProps={{
          style: {},
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: colors.red,
            borderColor: colors.red,
            color: colors.white,
          },
          onClick: handleReject,
        }}
        style={{
          direction: "rtl",
          minWidth: 300,
          maxWidth: 980,
          margin: "auto",
          background: colors.white,
          top: "30vh",
        }}
        width={"80%"}
      >
        <Typography.Text style={{ display: "block", marginBottom: 16 }}>
          {activeItem?.description}
        </Typography.Text>
        <Rate value={activeItem?.rate} disabled />
      </StyledModal>

      <Table
        loading={reload}
        columns={tableHeaders}
        dataSource={
          data?.length &&
          data?.map((item, index) => ({
            name: item.name,
            title: item.title,
            rate: (
              <>
                {item.rate}
                <span style={{ fontSize: 11 }}>/5</span>
              </>
            ),
            created_at: new Intl.DateTimeFormat("fa-IR").format(
              new Date(item.created_at)
            ),
            actions:
              item.status === 0 ? (
                <div className="center row">
                  <Button
                    style={{ marginRight: 6 }}
                    onClick={() => setActiveItem(item)}
                  >
                    <SafetyOutlined />
                  </Button>
                </div>
              ) : item.status === 1 ? (
                <div className="center">
                  تایید شده
                  <CheckOutlined
                    style={{
                      color: colors.green,
                      fontSize: 18,
                      marginRight: 5,
                    }}
                  />
                </div>
              ) : (
                <div className="center">
                  رد شده
                  <CloseOutlined
                    style={{
                      color: colors.red,
                      fontSize: 18,
                      marginRight: 5,
                    }}
                  />
                </div>
              ),
            key: index + 1,
          }))
        }
      />
    </>
  );
}

const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  { title: "عنوان نظر", dataIndex: "title", key: "title", align: "center" },
  {
    title: "نام مشتری",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  { title: "امتیاز", dataIndex: "rate", key: "rate", align: "center" },
  {
    title: "تاریخ",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
  },
  {
    title: "وضعیت",
    dataIndex: "actions",
    key: "actions",
    align: "center",
  },
];
